import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { I18nService, TranslatePipe } from '@recruitee/i18n';
import {
  DropdownWidth,
  IconName,
  DropdownItemComponent,
  IconComponent,
  DropdownHeaderComponent,
  DropdownComponent,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-search-page-query-input-info',
  templateUrl: './query-input-info.component.html',
  styleUrls: ['./query-input-info.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DropdownComponent,
    DropdownHeaderComponent,
    IconComponent,
    DropdownItemComponent,
    TranslatePipe,
  ],
})
export class SearchPageQueryInputInfoComponent {
  @Input() public fields: Array<{ icon: IconName; label: string }>;
  @Input() public readMoreLink: string;

  public DropdownWidth = DropdownWidth;

  public operators: Array<{ label: string; description: string }> = [
    {
      label: '<span>and</span>',
      description: this.i18n.translate('app.new_search_page.boolean_search_info.operators.and'),
    },
    {
      label: '<span>or</span>',
      description: this.i18n.translate('app.new_search_page.boolean_search_info.operators.or'),
    },
    {
      label: '<span>not</span>',
      description: this.i18n.translate('app.new_search_page.boolean_search_info.operators.not'),
    },
    {
      label: '<span>(</span>&nbsp;parentheses&nbsp;<span>)</span>',
      description: this.i18n.translate(
        'app.new_search_page.boolean_search_info.operators.parentheses',
      ),
    },
    {
      label: '<span>"</span>&nbsp;quotes&nbsp;<span>"</span>',
      description: this.i18n.translate('app.new_search_page.boolean_search_info.operators.quotes'),
    },
  ];

  constructor(private i18n: I18nService) {}

  public trackByIndex(index: number): number {
    return index;
  }

  public preventNonAnchorEventBubbling($event: MouseEvent): void {
    if ($event.target && !('href' in $event.target)) {
      $event.preventDefault();
    } else {
      $event.stopPropagation();
    }
  }
}
